import { graphql } from 'gatsby';
import React from 'react';
import {
  convertJustification,
  getSettingsClass,
  splitAfterLastDigit,
} from '~/utils/helpers';
import TextComponent from '../reusable/TextComponent';

interface NumbersProps {
  block: {
    settings: Settings;
    _template: string;
    css_class_name: string;
    content_alignment: string;
    background_color: string;
    value_text: ReusableTextFieldParameters;
    text_text: ReusableTextFieldParameters;
    value_unit_font_size?: number;
    container_alignment?: string;
    gap?: number;
    columns: {
      text: string;
      value: string;
      value_alignment: string;
    }[];
  };
}

const NumbersV2 = ({ block }: NumbersProps) => {
  let numbersBackgroundColorClass = '';
  if (block.background_color === 'White') {
    numbersBackgroundColorClass = 'bg-white';
  }

  const bg_class = block.background_color === 'White' ? 'bg-white' : '';

  const settingsClass = getSettingsClass(block.settings);

  const containerAlignmentJustification = convertJustification(
    block.container_alignment
  );

  return (
    <section
      className={`block ${block._template || ''} block__numbers block ${block.css_class_name || ''} ${bg_class || ''} ${settingsClass}`}
    >
      <div
        className='container'
        style={{
          paddingLeft: block.container_alignment === 'left' ? 0 : '',
          paddingRight: block.container_alignment === 'right' ? 0 : '',
        }}
      >
        <ul
          style={{
            justifyContent: containerAlignmentJustification
              ? containerAlignmentJustification
              : 'space-evenly',
            gap: block.gap ? `${block.gap}rem` : '',
          }}
        >
          {block.columns.map((column, index) => {
            const [value, unit] = splitAfterLastDigit(column.value);
            const valueAlignmentJustification = convertJustification(
              column.value_alignment
            );

            return (
              <li key={index}>
                <div
                  className='numbers-wr'
                  style={{
                    textAlign: block.content_alignment
                      ? (block.content_alignment as CanvasTextAlign)
                      : 'center',
                  }}
                >
                  {(value || unit) && (
                    <p
                      className={`value-holder flex items-end ${valueAlignmentJustification ? valueAlignmentJustification : 'justify-center'} gap-0`}
                    >
                      <TextComponent
                        data={{
                          ...block.value_text,
                          input_text: value || unit || '',
                        }}
                        className={`value ${(value || unit || '').startsWith('1') && column.value_alignment === 'left' ? 'ml-[-9px]' : ''}`}
                      />
                      {unit && value && (
                        <TextComponent
                          data={{
                            ...block.value_text,
                            input_font_size: block.value_unit_font_size || 1,
                            input_text: unit,
                          }}
                          className='value'
                        />
                      )}
                    </p>
                  )}
                  {column.text && (
                    <TextComponent
                      data={{ ...block.text_text, input_text: column.text }}
                      className='text'
                    />
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default NumbersV2;

export const blockNumbersV2Fragment = graphql`
  fragment BlockNumbersV2Fragment on Block {
    _template
    settings {
      ...SettingsFragment
    }
    background_color
    content_alignment
    value_text {
      ...ReusableTextFieldParameterFragment
    }
    value_unit_font_size
    text_text {
      ...ReusableTextFieldParameterFragment
    }
    container_alignment
    gap
    columns {
      value
      text
      value_alignment
    }
  }
`;
